export default __webpack_public_path__ + "40b8ca960681135603923373da4532e2.png";